import { createFeatureLogger } from '@/logger/utils/createFeatureLogger'

export const logger = createFeatureLogger('shiftCloseouts')
